// Enhance-text service configs for Post a Project (Atrium Stage 7).
//
// Group-map keyed by the JobPosting boolean column, consumed by services/index.js
// (the writing-group agent spreads WRITING_CONFIGS, DESIGN_MEDIA_CONFIGS, and
// ENHANCE_TEXT_CONFIGS into SERVICE_CONFIGS). See CONFIG-SCHEMA §0.

import { seo } from "./seo"
import { bookDescription } from "./bookDescription"
import { contentTranslation } from "./contentTranslation"
import { plagiarism } from "./plagiarism"
import { editing } from "./editing"
import { formatting } from "./formatting"

export const ENHANCE_TEXT_CONFIGS = {
  seo,
  book_description: bookDescription,
  content_translation: contentTranslation,
  plagiarism,
  editing,
  formatting,
}
